"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The main content for a section, e.g. a form.
 */
var Content = _styledComponents.default.div.withConfig({
  displayName: "Content",
  componentId: "sc-191qdj-0"
})(["width:100%;@media ", "{width:640px;}"], (0, _helpers.breakpoint)('minDesktop'));

var _default = Content;
exports.default = _default;